import type { ProductPriceSpec, SpaceModuleConfig } from "./SpaceType";

export const TRIAL_TIER_ID = "d7";

function filterTrialSpecs(specs: ProductPriceSpec[]): ProductPriceSpec[] {
  return specs.filter((s) => s.tierId !== TRIAL_TIER_ID);
}

/** 按用户试用资格过滤规格列表（含策略市场各 STRA） */
export function applyTrialTierVisibility(
  module: SpaceModuleConfig,
  trialTierVisible: boolean | null | undefined
): SpaceModuleConfig {
  if (trialTierVisible !== false) {
    return module;
  }
  return {
    ...module,
    priceSpecs: filterTrialSpecs(module.priceSpecs ?? []),
    strategySkuOffers: (module.strategySkuOffers ?? []).map((o) => ({
      ...o,
      priceSpecs: filterTrialSpecs(o.priceSpecs ?? []),
    })),
  };
}
